import { Box, Card, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArt, getArtsNotAdhered } from "../../../actions/art";
import TransferList from "../../commons/transferList/transferList";

const TransferListContainer = () => {
  const dispatch = useDispatch();

  const artsAdhered = useSelector((state) => state.art.listAssignedArts.list);
  const artsNotAdhered = useSelector(
    (state) => state.art.listArtsNotAdhered.list,
  );
  const loading = useSelector((state) => state.art.isFetching);
  const loadingArtsNotAdhered = useSelector(
    (state) => state.art.listArtsNotAdhered.isFetching,
  );
  const userName = useSelector((state) => state.auth.userName);

  useEffect(() => {
    if (!artsAdhered && !loading) dispatch(getArt());
    if (!artsNotAdhered && !loadingArtsNotAdhered)
      dispatch(getArtsNotAdhered());
  }, [artsAdhered, artsNotAdhered]);

  if (loading === true || loadingArtsNotAdhered) {
    return (
      <Card
        sx={{
          minHeight: "88%",
        }}>
        <Box
          sx={{
            justifyContent: "center",
            marginTop: "230px",
            textAlign: "center",
          }}>
          <CircularProgress size={40} />
        </Box>
      </Card>
    );
  }

  return (
    <Card
      sx={{
        minHeight: "88%",
      }}>
      <TransferList
        artsNotAdhered={artsNotAdhered}
        artsAdhered={artsAdhered}
        userName={userName}
      />
    </Card>
  );
};

export default TransferListContainer;
